import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from "react";
import { ChevronDown } from "react-feather";
import styles from "./EffektDropdown.module.scss";
import { useClickOutsideAlerter } from "../../../../hooks/useClickOutsideAlerter";
export const EffektDropdown: React.FC<{
  placeholder: string;
  searchable?: boolean;
  options: string[];
  onChange: (value: string) => void;
  value: string;
}> = t0 => {
  const $ = _c(34);
  const {
    placeholder,
    searchable,
    options,
    onChange,
    value
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useClickOutsideAlerter(wrapperRef, t1);
  let t2;
  if ($[1] !== isOpen) {
    t2 = () => {
      setIsOpen(!isOpen);
    };
    $[1] = isOpen;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const toggleOpen = t2;
  let t3;
  if ($[3] !== onChange) {
    t3 = value_0 => {
      setSelected(value_0);
      setIsOpen(false);
      onChange(value_0);
    };
    $[3] = onChange;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const select = t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[5] !== isOpen || $[6] !== options || $[7] !== placeholder || $[8] !== search || $[9] !== searchable || $[10] !== select || $[11] !== selected || $[12] !== toggleOpen) {
    let t9;
    if ($[18] !== search) {
      t9 = option => option.toLowerCase().includes(search.toLowerCase());
      $[18] = search;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    const filteredOptions = options.filter(t9);
    t7 = styles.wrapper;
    t8 = wrapperRef;
    t4 = styles.dropdown;
    const t10 = selected || placeholder;
    let t11;
    if ($[20] !== t10) {
      t11 = <span className={styles.dropdown__input__text}>{t10}</span>;
      $[20] = t10;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <div className={styles.dropdown__input__icon}><ChevronDown /></div>;
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    if ($[23] !== t11 || $[24] !== toggleOpen) {
      t5 = <div className={styles.dropdown__input} onClick={toggleOpen}>{t11}{t12}</div>;
      $[23] = t11;
      $[24] = toggleOpen;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    t6 = isOpen && <div className={styles.dropdown__options}>{searchable && <div className={styles.dropdown__options__search}><input type="text" placeholder={"S\xF8k"} value={search} onChange={e => setSearch(e.target.value)} /></div>}<div className={styles.dropdown__options__list}>{filteredOptions.map((option_0, i) => <div key={option_0} data-cy={`dropdown-option-${i}`} className={styles.dropdown__options__list__option} onClick={() => select(option_0)}>{option_0}</div>)}</div></div>;
    $[5] = isOpen;
    $[6] = options;
    $[7] = placeholder;
    $[8] = search;
    $[9] = searchable;
    $[10] = select;
    $[11] = selected;
    $[12] = toggleOpen;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t4 = $[13];
    t5 = $[14];
    t6 = $[15];
    t7 = $[16];
    t8 = $[17];
  }
  let t9;
  if ($[26] !== t4 || $[27] !== t5 || $[28] !== t6) {
    t9 = <div className={t4}>{t5}{t6}</div>;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
    t10 = <div className={t7} ref={t8}>{t9}</div>;
    $[30] = t7;
    $[31] = t8;
    $[32] = t9;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  return t10;
};